var _rect, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "#FFDDDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29.5H49.5",
    stroke: "#AE2100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 39.5V43.25C47 43.5815 46.8683 43.8995 46.6339 44.1339C46.3995 44.3683 46.0815 44.5 45.75 44.5H42C41.6685 44.5 41.3505 44.3683 41.1161 44.1339C40.8817 43.8995 40.75 43.5815 40.75 43.25V39.5",
    stroke: "#AE2100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.25 39.5V43.25C23.25 43.5815 23.1183 43.8995 22.8839 44.1339C22.6495 44.3683 22.3315 44.5 22 44.5H18.25C17.9185 44.5 17.6005 44.3683 17.3661 44.1339C17.1317 43.8995 17 43.5815 17 43.25V39.5",
    stroke: "#AE2100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 34.5H24.5",
    stroke: "#AE2100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 34.5H42",
    stroke: "#AE2100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47 29.5L42.3297 18.9922C42.2315 18.7713 42.0713 18.5836 41.8686 18.4518C41.6658 18.3201 41.4293 18.25 41.1875 18.25H22.8125C22.5707 18.25 22.3342 18.3201 22.1314 18.4518C21.9287 18.5836 21.7685 18.7713 21.6703 18.9922L17 29.5V39.5H47V29.5Z",
    stroke: "#AE2100",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.2ac1f36fa78d99bc90c68ebe9f00a60a.svg";
export { ForwardRef as ReactComponent };